import MemoryPanel from '../components/MemoryPanel';

// The market's memory, on Home: what the outside pages Navaris follows say.
export default function MarketWidget() {
    return <MemoryPanel scope="market" titled />;
}
